module.exports = "<div>\n  <app-project-box *ngFor='let p of projects.list' [project]='p'></app-project-box>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/project-dashboard/project-dashboard.component.html
// module id = ../../../../../src/app/project-dashboard/project-dashboard.component.html
// module chunks = main